import {Quote} from './quote';

// for representation
export class QuoteBarItem {
    constructor(private _quote: Quote, private _isPending: boolean) {
    }

    get quote(): Quote {
        return this._quote;
    }

    get isPending(): boolean {
        return this._isPending;
    }
}

export interface PendingQuoteCollection {
    [id: number]: boolean;
}
